import React from "react";
import { Box, Link, SxProps, Typography } from '@mui/material';
import InstallPWA from "../home/installAppButton";

interface IFooterProps {
  style?: SxProps;
}

const Footer: React.FC<IFooterProps> = (props: IFooterProps) => {
  const { style } = props;
  return (
    <Box sx={{  display: 'flex', flexDirection: 'column', paddingTop:'15px', width: '100%', position: 'relative', bottom: '0px', ...style}}>
      <Box
        sx={{
          display: 'flex',
          fontFamily: 'Oswald',
          justifyContent: 'center',
          fontSize: '18px',
          color: 'whitesmoke',
          paddingBottom: '10px',
          width: '100%',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignSelf:'center', justifyContent: 'center', gap: '5px'}}>
          <Typography sx={{ paddingLeft: '42px'}}>
            {`© Copyright ${new Date().getFullYear()} | All Rights Reserved`}
          </Typography>
          <Typography>
            Created By&nbsp;&nbsp;
            <Link
              id='marwan-linkedin'
              className="name"
              target="new"
              href="https://linkedin.com/in/marwan9"
              sx={{
                color: 'black',
                textDecoration: 'none',
                background:'white',
                padding: '2px 5px',
                borderRadius: '10px',
                marginRight: '7px',
                transition: 'background 0.2s ease',
                ':hover': {
                  background: 'black',
                  color: 'white',
                }
              }}
            >
              Marwan Mostafa
            </Link>
            <p
              className="name" 
              style={{
                display: 'inline', 
                color: 'black', 
                background:'white',
                padding: '2px 2px',
                borderRadius: '10px',
                marginRight: '7px'
              }}>
              &nbsp; &amp; &nbsp;
            </p>
            <Link
              id='khaled-linkedin'
              href="https://linkedin.com/in/khalidmamdou7"
              target="new"
              sx={{
                color: 'black',
                textDecoration: 'none',
                background:'white',
                padding: '2px 5px',
                borderRadius: '10px',
                transition: 'background 0.2s ease',
                ':hover': {
                  background: 'black',
                  color: 'white'
                }
              }}
            >
              Khaled Mamdouh
            </Link>
          </Typography>
        </Box>
      </Box>
      <InstallPWA/>
    </Box>
  );
}

export default Footer;
